import client from 'app/client';

export interface OperationResponse {
  isSuccess: boolean;
  errorMessage?: string;
  id?: string;
}

export interface PersonneMoralePlateformeDto {
  plateformeId: string;
  displayName: string;
  /** True si cette PM est la propriétaire (PlateformeOwner) de l'OU. */
  isPlateformeOwner: boolean;
  dateRattachement: string;
}

export interface GetPersonneMoralePlateformesResponse {
  personneMoraleId: string;
  plateformes: PersonneMoralePlateformeDto[];
}

export async function getPersonneMoralePlateformes(
  personneMoraleId: string,
): Promise<GetPersonneMoralePlateformesResponse> {
  const { data } = await client.get<GetPersonneMoralePlateformesResponse>(
    `/backoffice/personnes-morales/${personneMoraleId}/plateformes`,
  );
  return data;
}

export async function addPersonneMoralePlateforme(
  personneMoraleId: string,
  plateformeId: string,
): Promise<OperationResponse> {
  const { data } = await client.post<OperationResponse>(
    `/backoffice/personnes-morales/${personneMoraleId}/plateformes`,
    { plateformeId },
  );
  return data;
}

export async function removePersonneMoralePlateforme(
  personneMoraleId: string,
  plateformeId: string,
): Promise<OperationResponse> {
  const { data } = await client.delete<OperationResponse>(
    `/backoffice/personnes-morales/${personneMoraleId}/plateformes/${plateformeId}`,
  );
  return data;
}

// --- Liste de toutes les plateformes disponibles (pour le sélecteur d'ajout) ---

export interface PlateformeOption {
  id: string;
  displayName: string;
}

export async function getAllPlateformes(): Promise<PlateformeOption[]> {
  // Endpoint réel : GET /backoffice/plateformes/liste
  const { data } = await client.get<any>('/backoffice/plateformes/liste');
  const list = data?.plateformes ?? data?.items ?? (Array.isArray(data) ? data : []);
  return list.map((o: any) => ({
    id: o.id,
    displayName: o.displayName ?? o.name ?? o.designation ?? '(sans nom)',
  }));
}
